import { render, staticRenderFns } from "./SkuDetail.vue?vue&type=template&id=85a71348&scoped=true"
import script from "./SkuDetail.vue?vue&type=script&lang=js"
export * from "./SkuDetail.vue?vue&type=script&lang=js"
import style0 from "./SkuDetail.vue?vue&type=style&index=0&id=85a71348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a71348",
  null
  
)

export default component.exports